/**
 * Typed Query Keys registry for TanStack Query.
 * Organizes cache keys for all features in a centralized, type-safe manner.
 */
export const queryKeys = {
  auth: {
    me: () => ['auth', 'me'] as const,
  },
  tenant: {
    me: () => ['tenant', 'me'] as const,
  },
  users: {
    list: (filters?: Record<string, any>) => ['users', 'list', filters] as const,
    byId: (id: number) => ['users', 'byId', id] as const,
  },
  projects: {
    list: (filters?: Record<string, any>) => ['projects', 'list', filters] as const,
    byId: (id: number) => ['projects', 'byId', id] as const,
  },
  lineItems: {
    list: (projectId: number, filters?: Record<string, any>) => ['lineItems', 'list', projectId, filters] as const,
    byId: (id: number) => ['lineItems', 'byId', id] as const,
  },
  catalogue: {
    materials: () => ['catalogue', 'materials'] as const,
    windowTypes: (materialId?: number) => ['catalogue', 'windowTypes', materialId] as const,
    series: (material?: string, windowTypeId?: number) => ['catalogue', 'series', material, windowTypeId] as const,
    sashes: (materialId?: number, windowTypeId?: number, seriesId?: number) => ['catalogue', 'sashes', materialId, windowTypeId, seriesId] as const,
    types: (seriesId: number, windowTypeId?: number) => ['catalogue', 'types', seriesId, windowTypeId] as const,
    combinations: (
      materialId?: number,
      windowTypeId?: number,
      seriesId?: number,
      typeId?: number,
      sashId?: number,
      frameStyle?: string
    ) => ['catalogue', 'combinations', materialId, windowTypeId, seriesId, typeId, sashId, frameStyle] as const,
    resolvedCombination: (id: number) => ['catalogue', 'resolvedCombination', id] as const,
  },
  optimisation: {
    runs: (projectId?: number) => ['optimisation', 'runs', projectId] as const,
    byId: (id: number) => ['optimisation', 'byId', id] as const,
  },
  offcuts: {
    list: (filters?: Record<string, any>) => ['offcuts', 'list', filters] as const,
  },
  exports: {
    list: (filters?: Record<string, any>) => ['exports', 'list', filters] as const,
    downloadUrl: (id: number) => ['exports', 'downloadUrl', id] as const,
  },
} as const;
